/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumTypeEnumSchema } from "./albumTypeEnumSchema.ts";
import { z } from "zod";

export const createOrUpdateAlbumModelSchema = z.object({
    "name": z.string().max(150).describe("Название альбома"),
"pictureFileId": z.string().uuid().describe("Идентификатор файла-обложки"),
"type": z.lazy(() => albumTypeEnumSchema).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыкальный альбом</li>\n<li><b>2 - Podcast</b>: Альбом подкастов</li>\n<li><b>3 - Book</b>: Альбом книг</li>\n<li><b>4 - Sermon</b>: Альбом проповедей</li>\n</ul>\n"),
"releaseDate": z.string().date().describe("Дата выпуска").nullable().nullish(),
"excludeSearch": z.boolean().describe("Исключить из поиска"),
"tagIds": z.array(z.number().int()).describe("Идентификаторы жанров").nullable().nullish(),
"authorId": z.string().uuid().describe("Идентификатор основного автора"),
"coauthorIds": z.array(z.string().uuid()).describe("Идентификаторы соавторов").nullable().nullish()
    })